import MainPageContent from "./MainPageContent/MainPageContent"
import classes from './MainPage.module.scss'


const MainPage = () => {

    return (
        <div className={classes.mainContainer}>
                <MainPageContent/>
        </div>
    )
}

export default MainPage